<template>
  <section>
    <h1>{{ $t('authCallback.login') }}</h1>
    <panel>
      <template v-if="isError">
        <div v-if="isNotFound">
          <p>{{ $t('authCallback.accountNotFound') }}</p>
          <p>{{ $t('authCallback.pleaseConfirmLogin') }}</p>
          <p>
            {{ $t('authCallback.autoRedirectNote.beforeLink') }}
            <a href="https://twitter.com/" target="_blank">{{ $t('authCallback.autoRedirectNote.linkLabel') }}</a>
            {{ $t('authCallback.autoRedirectNote.afterLink') }}
          </p>
        </div>
        <div v-else-if="isCancelled">
          <p>{{ $t('authCallback.cancelled') }}</p>
        </div>
        <div v-else>
          <p>{{ $t('authCallback.unknownError') }}</p>
        </div>
        <p><enlil-button @click="onBackButtonClick">{{ $t('authCallback.backToLogin') }}</enlil-button></p>
      </template>
      <div v-else>
        <p>{{ $t('authCallback.loggingIn') }}</p>
      </div>
    </panel>
  </section>
</template>

<style lang="scss" scoped>
p {
  line-height: 1.5em;
}
</style>

<script>
import { mapActions } from 'vuex'

import EnlilButton from '../../components/EnlilButton.vue'
import Panel from '../../components/Panel.vue'

import Consts from '../../lib/Consts'
import parseQueryString from '../../lib/parseQueryString'

export default {
  name: 'auth-callback',
  components: {
    EnlilButton,
    Panel
  },
  data: () => ({
    isError: false,
    isNotFound: false,
    isCancelled: false
  }),
  methods: {
    ...mapActions('session', ['login']),
    ...mapActions(['displayAlert']),
    onBackButtonClick () {
      this.$router.push('/auth')
    }
  },
  mounted () {
    const queryString = parseQueryString()

    if (!(Object.keys(queryString).length > 0)) {
      this.$router.replace('/')
      return
    }

    if (!('auth_token' in queryString && 'error' in queryString)) {
      this.displayAlert({ message: this.$t('authCallback.lackOfParameter') })
      this.$router.replace('/auth')
      return
    }

    if (queryString.error !== null) {
      this.isError = true
      if (queryString.error === Consts.CALLBACK_ERROR_NOT_FOUND) {
        this.isNotFound = true
      } else if (queryString.error === Consts.CALLBACK_ERROR_CANCELLED) {
        this.isCancelled = true
      }

      return
    }

    if (typeof queryString.auth_token !== 'string') {
      this.displayAlert({ message: this.$t('authCallback.noAccessToken') })
      this.$router.replace('/auth')
      return
    }

    this.login({ accessToken: queryString.auth_token })
    localStorage.setItem(Consts.LS_KEY_FLASH_MESSAGE, this.$t('app.loggedIn'))

    location.href = '/jewel_exchange/#/'
  }
}
</script>
